import { absolutePath } from "../absolutePath";

interface SearchFnProps {
  params?: Record<string, unknown>;
}

export const search = {
  communityMembers: {
    index: ({ params = {} }: SearchFnProps) =>
      absolutePath("admin/search/community_members", params),
    /* Enable multiple instances and operators */
    indexV2: ({ params = {} }: SearchFnProps) =>
      absolutePath("v2/admin/search/community_members", params, {
        arrayFormat: "indices",
      }),
  },
  contacts: {
    index: ({ params = {} }: SearchFnProps) =>
      absolutePath("v2/admin/search/contacts", params, {
        arrayFormat: "indices",
      }),
  },
};
